<template>
    <div class="supporters columns is-multiline">
        <div class="column is-full mb-5" v-if="!user">
            <cat-uxo-hero
                :heading="heroHeading"
                :content="heroContent"
            >
            </cat-uxo-hero>
        </div>

        <div class="column is-12-mobile is-12-tablet is-5-widescreen mb-3 mb-lg-0">
            <h3 class="mb-12px">Top Contributors</h3>
            <template v-if="fetchingContributors">
                <div class="content-loader">
                    <ContentLoader
                        :height="500"
                        :width="500"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="0" y="0" rx="0" ry="0" width="500" height="56"/>
                        <rect x="0" y="72" rx="0" ry="0" width="500" height="56"/>
                        <rect x="0" y="144" rx="0" ry="0" width="500" height="56"/>
                        <rect x="0" y="216" rx="0" ry="0" width="500" height="56"/>
                    </ContentLoader>
                </div>
            </template>
            <template v-else>
                <ul class="contributors rows" v-if="topContributors">
                    <template v-for="(contributor, index) in topContributors">
                        <li class="contributor row columns t-navy px-1 px-md-3 py-12px" v-if="index <= 4">
                            <div class="column p-0 contributor__name py-12px">{{index + 1}}. {{contributor[0].name}}
                            </div>
                            <div class="column p-0 contributor__total font-weight-light">{{contributor.length}}
                                Contributions
                            </div>
                            <div class="column p-0 contributor__btn text-sm-right">
                                <a v-if="user && (user.eod_technician || user.technical_interest)"
                                   :href="`/members/${contributor[0].contributor_id}`"
                                   class="btn btn-ghost bg-white">View Profile</a>

                                <a v-if="user && user.guest"
                                   :href="`/sign-up`"
                                   class="btn btn-ghost bg-white">Sign Up</a>

                                <a v-if="!user"
                                   :href="`/login`"
                                   class="btn btn-ghost bg-white">Login</a>
                            </div>
                        </li>
                    </template>
                </ul>
            </template>
        </div>

        <div class="column is-12-mobile is-12-tablet is-7-widescreen">
            <h3 class="mb-12px">Contributors</h3>
            <template v-if="fetchingContributors">
                <div class="content-loader">
                    <ContentLoader
                        :height="500"
                        :width="500"
                        :speed="2"
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="0" y="0" rx="0" ry="0" width="500" height="56"/>
                        <rect x="0" y="72" rx="0" ry="0" width="500" height="56"/>
                        <rect x="0" y="144" rx="0" ry="0" width="500" height="56"/>
                        <rect x="0" y="216" rx="0" ry="0" width="500" height="56"/>
                    </ContentLoader>
                </div>
            </template>
            <template v-else>
                <ul class="contributors rows" v-if="contributors">
                    <template v-for="contributor in contributors">
                        <li class="contributor row columns t-navy px-1 px-md-3 py-12px">
                            <div class="column p-0 contributor__name py-12px">{{contributor[0].name}}</div>
                            <div class="column p-0 contributor__total font-weight-light">{{contributor.length}}
                                Contributions
                            </div>
                            <div class="column p-0 contributor__btn text-sm-right">
                                <a v-if="user && (user.eod_technician || user.technical_interest)"
                                   :href="`/members/${contributor[0].contributor_id}`"
                                   class="btn btn-ghost bg-white">View Profile</a>

                                <a v-if="user && user.guest"
                                   :href="`/sign-up`"
                                   class="btn btn-ghost bg-white">Sign Up</a>

                                <a v-if="!user"
                                   :href="`/login`"
                                   class="btn btn-ghost bg-white">Login</a>
                            </div>
                        </li>
                    </template>
                </ul>
            </template>
        </div>
    </div>
</template>

<script>

    import {ContentLoader} from 'vue-content-loader'
    import {mapActions, mapGetters, mapState} from "vuex";

    export default {
        name: "CatUxoPageSupporters",
        components: {
            ContentLoader,
        },
        props: {
            user: {
                type: Object
            }
        },
        data: function () {
            return {
                heroHeading: "CAT-UXO Members",
                heroContent: "If you’re a Technical Interest or EOD Technician Member then you’ll be able to view your name in the list of members below, along with your number of contributions and a link to your profile.",
            }
        },
        methods: {
            ...mapActions('contributor', [
                'fetchContributors',
            ]),
        },
        computed: {
            ...mapState('contributor', [
                'fetchingContributors',
                'contributors',
            ]),
            ...mapGetters('contributor', [
                'topContributors',
            ]),
        },
        created() {
            this.fetchContributors();
        },
        mounted() {
        }
    }

</script>

<style lang="scss" scoped>

    .content-loader {
        min-height: rem(300px);
        min-width: rem(300px);
        width: 100%;

        @include media-breakpoint-up(sm) {
            min-height: rem(300px);
        }
    }

    .contributor {
        &:nth-child(even) {
            background: $c-light-grey;
        }

        &:nth-child(odd) {
            background: $c-white;
        }
    }

    @include media-breakpoint-down(xs) {
        .contributor {
            flex-wrap: wrap;

            .column {
                flex-basis: auto;
            }

            &__name,
            &__total {
                width: 100%;
            }

            &__total {
                margin-bottom: rem(12px);
            }
        }
    }

    @include media-breakpoint-down(lg) {
        .supporters {
            margin-top: rem(-32px);
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/Supporters.vue